// Masraf fişi giriş doğrulaması. Fiş GÖRSELİ zorunludur (müşteri talebi
// 2026-08-28): görselsiz fiş, onaylayan için doğrulanamaz bir kalem demek.
// Daha önce yüklenmiş kayıtlı adres (mediaUrl) görsel yerine geçer.
export function isReceiptComplete(receipt) {
  if (!receipt) return false;

  const amount = parseFloat(receipt.amount);
  if (!amount || amount < 0) return false;

  const tax = parseFloat(receipt.taxRate);
  if (Number.isNaN(tax) || tax < 0) return false;

  if (!receipt._file && !receipt.mediaUrl) return false;

  if (receipt.date) {
    const receiptDate = new Date(receipt.date);
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (receiptDate > today) return false;
  }

  return true;
}

export default isReceiptComplete;
